import AbstractHybrisApi from '@/api/AbstractHybrisApi';

export default class DonationApi extends AbstractHybrisApi {
  friends(date: string, period: string, lang: null | string) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: `/donation/friends`,
      params: {
        fields: 'FULL',
        lang,
        date,
        period,
      },
    });
  }
}
